import axios from 'axios';
import { ICrudGetAction, ICrudGetAllAction, ICrudPutAction, ICrudDeleteAction } from 'react-jhipster';

import { cleanEntity } from '../../../utils/entity-utils';
import { REQUEST, SUCCESS, FAILURE } from '../action-type.util';

import { IWarningTemplates, defaultValue } from '../../model/warning-templates.model';

export const ACTION_TYPES = {
  FETCH_WARNINGTEMPLATES_LIST: 'warningTemplates/FETCH_WARNINGTEMPLATES_LIST',
  FETCH_WARNINGTEMPLATES: 'warningTemplates/FETCH_WARNINGTEMPLATES',
  CREATE_WARNINGTEMPLATES: 'warningTemplates/CREATE_WARNINGTEMPLATES',
  UPDATE_WARNINGTEMPLATES: 'warningTemplates/UPDATE_WARNINGTEMPLATES',
  DELETE_WARNINGTEMPLATES: 'warningTemplates/DELETE_WARNINGTEMPLATES',
  SET_BLOB: 'warningTemplates/SET_BLOB',
  RESET: 'warningTemplates/RESET',
};

const initialState = {
  loading: false,
  errorMessage: null,
  entities: [] as ReadonlyArray<IWarningTemplates>,
  entity: defaultValue,
  updating: false,
  totalItems: 0,
  updateSuccess: false,
};

export type WarningTemplatesState = Readonly<typeof initialState>;

// Reducer

export default (state: WarningTemplatesState = initialState, action): WarningTemplatesState => {
  switch (action.type) {
    case REQUEST(ACTION_TYPES.FETCH_WARNINGTEMPLATES_LIST):
    case REQUEST(ACTION_TYPES.FETCH_WARNINGTEMPLATES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        loading: true,
      };
    case REQUEST(ACTION_TYPES.CREATE_WARNINGTEMPLATES):
    case REQUEST(ACTION_TYPES.UPDATE_WARNINGTEMPLATES):
    case REQUEST(ACTION_TYPES.DELETE_WARNINGTEMPLATES):
      return {
        ...state,
        errorMessage: null,
        updateSuccess: false,
        updating: true,
      };
    case FAILURE(ACTION_TYPES.FETCH_WARNINGTEMPLATES_LIST):
    case FAILURE(ACTION_TYPES.FETCH_WARNINGTEMPLATES):
    case FAILURE(ACTION_TYPES.CREATE_WARNINGTEMPLATES):
    case FAILURE(ACTION_TYPES.UPDATE_WARNINGTEMPLATES):
    case FAILURE(ACTION_TYPES.DELETE_WARNINGTEMPLATES):
      return {
        ...state,
        loading: false,
        updating: false,
        updateSuccess: false,
        errorMessage: action.payload,
      };
    case SUCCESS(ACTION_TYPES.FETCH_WARNINGTEMPLATES_LIST):
      return {
        ...state,
        loading: false,
        entities: action.payload.data,
        totalItems: parseInt(action.payload.headers['x-total-count'], 10),
      };
    case SUCCESS(ACTION_TYPES.FETCH_WARNINGTEMPLATES):
      return {
        ...state,
        loading: false,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.CREATE_WARNINGTEMPLATES):
    case SUCCESS(ACTION_TYPES.UPDATE_WARNINGTEMPLATES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: action.payload.data,
      };
    case SUCCESS(ACTION_TYPES.DELETE_WARNINGTEMPLATES):
      return {
        ...state,
        updating: false,
        updateSuccess: true,
        entity: {},
      };
    case ACTION_TYPES.SET_BLOB: {
      const { name, data, contentType } = action.payload;
      return {
        ...state,
        entity: {
          ...state.entity,
          [name]: data,
          [name + 'ContentType']: contentType,
        },
      };
    }
    case ACTION_TYPES.RESET:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

const apiUrl = 'api/warning-templates';

// Actions

export const getEntities: ICrudGetAllAction<IWarningTemplates> = (page, size, sort) => {
  const requestUrl = `${apiUrl}${sort ? `?page=${page}&size=${size}&sort=${sort}` : ''}`;
  return {
    type: ACTION_TYPES.FETCH_WARNINGTEMPLATES_LIST,
    payload: axios.get<IWarningTemplates>(`${requestUrl}${sort ? '&' : '?'}cacheBuster=${new Date().getTime()}`),
  };
};

export const getEntity: ICrudGetAction<IWarningTemplates> = id => {
  const requestUrl = `${apiUrl}/${id}`;
  return {
    type: ACTION_TYPES.FETCH_WARNINGTEMPLATES,
    payload: axios.get<IWarningTemplates>(requestUrl),
  };
};

export const createEntity: ICrudPutAction<IWarningTemplates> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.CREATE_WARNINGTEMPLATES,
    payload: axios.post(apiUrl, cleanEntity(entity)),
  });
  dispatch(getEntities());
  return result;
};

export const updateEntity: ICrudPutAction<IWarningTemplates> = entity => async dispatch => {
  const result = await dispatch({
    type: ACTION_TYPES.UPDATE_WARNINGTEMPLATES,
    payload: axios.put(apiUrl, cleanEntity(entity)),
  });
  return result;
};

export const deleteEntity: ICrudDeleteAction<IWarningTemplates> = id => async dispatch => {
  const requestUrl = `${apiUrl}/${id}`;
  const result = await dispatch({
    type: ACTION_TYPES.DELETE_WARNINGTEMPLATES,
    payload: axios.delete(requestUrl),
  });
  dispatch(getEntities());
  return result;
};

export const setBlob = (name, data, contentType?) => ({
  type: ACTION_TYPES.SET_BLOB,
  payload: {
    name,
    data,
    contentType,
  },
});

export const reset = () => ({
  type: ACTION_TYPES.RESET,
});
